export default {
  textField: {
    margin: "10px 15px",
    fontSize: "14px",
    color: "#003764",
    "& label": {
      fontSize: "14px",
      color: "#003764",
      top:"5px",
    },
    "& input": {
      width: "266px",
      height: "25px",
      borderWidth: "0 0 1px",
      borderColor: "#003764"
    },
    "& p": {
      width: "267px",
      position:"absolute",
      top:"50px",
    },
    "& input:focus" : {
      outline: "none"
    },
    "& input::placeholder" : {
      color: "#003764;"
    },
  },
  optionalTextField: {
    margin: "10px 15px",
    fontSize: "14px",
    color: "#003764",
    "& label": {
      fontSize: "14px",
      color: "#003764",
      top:"5px",
      width : "360px",
    },
    "& input": {
      width: "198px",
      height: "25px",
      borderWidth: "0 0 1px",
      borderColor: "#003764"
    },
    "& p": {
      width: "267px",
      position:"absolute",
      top:"50px",
    },
    "& input:focus" : {
      outline: "none"
    },
    "& input::placeholder" : {
      color: "#003764"
    },
  },
  inputAdornment : {
    color: "#00A5B5",
    fontSize: "14px"
  },
  enrollerName : {
    color : "rgba(0, 0, 0, 0.38)",
  },
  sponsorTextField: {
    margin: "10px 15px",
    fontSize: "14px",
    color: "#003764",
    "& label": {
      fontSize: "14px",
      color: "#003764",
      top:"5px",
    },
    "& input": {
      width: "198px",
      height: "15px",
      borderWidth: "0 0 1px",
      borderColor: "#003764"
    },
    "& p": {
      width: "267px",
      position:"absolute",
      top:"50px",
    },
    "& input:focus" : {
      outline: "none"
    },
    "& input::placeholder" : {
      color: "#003764"
    },
  },
  sponsorEnrollerName : {
    color : "rgba(0, 0, 0, 0.38)",
    //marginLeft : "15px",
    //marginTop : "5px",
    fontSize : "12px",
    width : "250px",
  },
  labelContainer : {
    display : "flex",
    flexDirection : "row",
    flexWrap : "nowrap",
    justifyContent: "space-between",
    //backgroundColor: "lightyellow",
  },
  refEnrollerError : {
    color : "red",
    textAlign: "right",
    bottom : "0",
    width : "100%",
  },
  //new - design
  labelContent : {
    fontSize: "14px",
    fontWeight: "600",
    color: "#153862"
  },
  textFld: {
    background: "#F7FAFC",
    borderRadius: "10px",
    "& input": {
      //width: "466px",
      height: "32px",
      padding: "10px"
    },
  },
  textDis: {
    background: "#F7FAFC",
    borderRadius: "10px",
    width: "100%",
    "& input": {
      height: "32px",
      padding: "10px"
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/StartContainer/Sponsor/sponsor.style.js